import React from 'react';

export default function LeftQuote(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 49 39"
      style={{ enableBackground: 'new 0 0 49 39' }}
      xmlSpace="preserve"
      width={49}
      height={39}
      {...props}
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n\t.st0{opacity:0.3073;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FAA918;}\n',
        }}
      />
      <title>“</title>
      <desc>Created with Sketch.</desc>
      <g id="Onboarding" className="st0">
        <g
          id="District_x2F_School-Product-Payment-_x26_-Signing-_x2F_-Success"
          transform="translate(-348.000000, -1224.000000)"
        >
          <g className="st1">
            <path
              className="st2"
              d="M352.5,1249.1c0-4.3,1.1-8.4,3.2-12.3c2.2-3.9,4.9-7.1,8.4-9.5l5.3,4.4c-2.3,1.5-4.4,3.6-6.2,6.2
            				s-2.8,5.1-3.1,7.4l0.8-0.1c0.5-0.1,0.8-0.1,1.1-0.1c2,0,3.7,0.7,5,2.1c1.3,1.4,2,3.1,2,5.1c0,2.1-0.8,3.9-2.2,5.4
            				c-1.5,1.5-3.3,2.2-5.5,2.2c-2.5,0-4.7-1-6.4-2.9C353.4,1255,352.5,1252.4,352.5,1249.1z M375.5,1249.1c0-4.3,1.1-8.4,3.3-12.3
            				s5-7.1,8.4-9.5l5.3,4.4c-2.3,1.5-4.4,3.6-6.2,6.2s-2.8,5.1-3.1,7.4c0,0,0.3,0,0.8-0.1c0.5-0.1,0.8-0.1,1.1-0.1
            				c2,0,3.7,0.7,5.1,2.1c1.4,1.4,2,3.1,2,5.1c0,2.1-0.8,3.9-2.3,5.4c-1.5,1.5-3.4,2.2-5.5,2.2c-2.5,0-4.7-1-6.4-2.9
            				C376.3,1255,375.5,1252.4,375.5,1249.1z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/LeftQuote.svg.jsx